import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpi-overview',
  templateUrl: './kpi-overview.component.html',
  styleUrls: ['./kpi-overview.component.scss']
})
export class KpiOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
